var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bell",on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":require("@/assets/images/bell.png"),"alt":"提醒"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }